import moment from 'moment';
import store from '../../stores/store';
import { Subscription } from '@/stores/store.types';

export function calculatePermissions(subscriptionsParameter?: Subscription[]) {
  const subscriptions =
    subscriptionsParameter ?? store.getState()?.subscriptions;

  let freePlan;
  let extraPlan;

  let permissions: Subscription = {
    plan: 'gratis',
    pictureCards: false,
    exercises: false,
    eigentraining: false,
  };

  if (subscriptions) {
    subscriptions.forEach((subscription) => {
      if (subscription.plan === 'gratis') {
        freePlan = subscription;
      } else {
        extraPlan = subscription;
      }
    });

    // If there is an premium plan check if is still valid and put it as current permissions
    if (extraPlan && !isExpired(extraPlan)) {
      permissions = extraPlan;
    }
    //otherwise there is only the free plan
    else if (freePlan) {
      permissions = freePlan;
    }
  }

  if (!subscriptionsParameter) {
    store.getActions().setPermissions(permissions);
  }

  return permissions;
}

// check if (premium) plan is expired
function isExpired(plan: { expiresAt: Date }) {
  let currentTime = moment().unix();

  let expiryTime = plan.expiresAt;
  let isExpired = moment(currentTime).isAfter(expiryTime);

  return isExpired;
}
